import React from "react";

import { CrossIcon } from "../../../../../resource/icons";
import AnswerCheckBox from "./answer-checkbox";

const OtherAnswer = (props) => {
	const { questionId, onDeleteOther } = props;

	return (
		<div className="answer">
			<div className="answer-options">
				<AnswerCheckBox questionId={questionId} {...props} />
				<div className="field-input field">Другое</div>
				<CrossIcon className="icon" onClick={onDeleteOther} />
			</div>
		</div>
	);
};

export default OtherAnswer;
